import { FC, useState } from 'react';
import { Button, Checkbox, Modal } from 'antd';

import close from '../../assets/RoundedClose.svg';

interface ModalProps {
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    SupplierProcced: () => void;
}

export const AddSuppInfoModal: FC<ModalProps> = ({ openModal, setOpenModal, SupplierProcced }) => {
    const [checkbox, setCheckbox] = useState(false);
    const [error, setError] = useState(false);
    return (
        <>
            <Modal
                className="modal-modal"
                destroyOnClose
                centered
                open={openModal}
                onOk={() => {}}
                onCancel={() => {
                    setOpenModal(false);
                }}
                closeIcon={<img src={close} />}
                footer={
                    <div
                        style={{
                            display: 'flex',
                            justifyItems: 'space-between',
                            gap: '16px',
                            width: '100%',
                            margin: '20px 0 0 0'
                        }}
                    >
                        <Button block onClick={() => setOpenModal(false)}>
                            Cancel
                        </Button>
                        <Button
                            block
                            key="submit"
                            type="primary"
                            onClick={() => {
                                if (checkbox) {
                                    SupplierProcced();
                                    setOpenModal(false);
                                } else {
                                    setError(true);
                                }
                            }}
                        >
                            Add suppliers
                        </Button>
                    </div>
                }
            >
                <div className="modal">
                    <div className="modal__header meeting" style={{ height: '88px' }}>
                        <div className="modal__title">Add a New Supplier</div>
                    </div>

                    <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                        <div className="main__title">
                            You can invite additional suppliers to join this service opportunity.
                        </div>

                        <div className="main__subtitle">To be included, they must:</div>
                        <ul>
                            <li>Register on Proco</li>
                            <li>Accept our Supplier Terms</li>
                            <li>Upload their basic company documents</li>
                        </ul>
                        <br />
                        <ul>
                            <li>Inviting a supplier doesn’t guarantee participation.</li>
                            <li>
                                Suppliers have 7 calendar days to complete registration — late submissions cannot be
                                accepted.
                            </li>
                            <li>Manually added suppliers may not fully align with your selected requirements.</li>
                            <li>After this phase, no further suppliers can be added at any stage.</li>
                            <li>
                                We recommend letting invited suppliers know directly that an invitation is on its way
                            </li>
                        </ul>
                        <Checkbox
                            checked={checkbox}
                            onChange={() => {
                                setCheckbox((prev) => !prev);
                                setError(false);
                            }}
                        >
                            <div className="main__title" style={{ margin: '0' }}>
                                I understand suppliers must register within 7 calendar days and no further suppliers can
                                be added after this phase.
                            </div>
                        </Checkbox>
                        {error && <div className="error-text">You must agree to the terms before continuing</div>}
                    </div>
                </div>
            </Modal>
        </>
    );
};
